exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".name-field {\r\n    border: none;\r\n    background: white;\r\n    width: 100%;\r\n    outline: none;\r\n}\r\n\r\n/* .tr-focus {\r\n    background: #f5f5f5;\r\n} */\r\n\r\ntable.upload-file tr:focus-within {\r\n    background: #f5f5f5;\r\n}\r\n::ng-deep ui-switch {\r\n    color: white;\r\n}\r\n::ng-deep .switch.switch-small{ border-radius: 4px; }\r\n::ng-deep .switch.switch-small small {\r\nwidth: 21px;\r\nheight: 25px;\r\nright: calc(100% - 21px);\r\nborder-radius: 4px;\r\nmargin-top: -3px;\r\n}\r\n::ng-deep .switch.checked.checked small {\r\n    top: 0;\r\n    right: 0;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// G:/UTL/BMI/Admin/Admin-ANG/src/app/shared/file-upload/file-upload.component.css
// module id = ../../../../../src/app/shared/file-upload/file-upload.component.css
// module chunks = main